import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NavController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { FBaseService } from './firebase/f-base.service';
import * as semver from 'semver';

@Injectable({
    providedIn: 'root',
})
export class VersionService implements OnDestroy {
    versionSubject = new BehaviorSubject<boolean | null>(null);
    versionIsValid$ = this.versionSubject.asObservable();
    versionToast: HTMLIonToastElement | undefined;
    versionSub?: Subscription;

    constructor(
        private navController: NavController,
        private firebaseService: FBaseService
    ) { }

    private getNewestVersion() {
        return this.firebaseService.getDataByField('SystemConfig', [{ fieldPath: 'isActive', opStr: '==', value: true }], { active: 'metadata.lastUpdatedAt', direction: 'desc' }, 1);
    }

    subscribeToVersionChanges() {
        const currentVersion = environment.version;
        this.versionSub = this.getNewestVersion().subscribe(async configs => {
            const config = configs[0];
            const minimumRequiredVersion = config?.studentApp?.minimumRequiredVersion || '';
            console.log('App current version:', currentVersion, '\nRequired minimum app version:', minimumRequiredVersion);
            const isValid = minimumRequiredVersion ? semver.gte(currentVersion, minimumRequiredVersion) : true;
            const path = window?.location?.pathname;
            if (isValid) {
                if (path.includes('update-needed')) {
                    await this.navController.navigateRoot('/');
                }
            } else {
                await this.navController.navigateRoot('update-needed');
            }
            this.versionSubject.next(isValid);
        });
    }

    ngOnDestroy() {
        this.versionSub?.unsubscribe();
    }

}
